import { render, staticRenderFns } from "./EtiketView.vue?vue&type=template&id=15aea39c&"
import script from "./EtiketView.vue?vue&type=script&lang=js&"
export * from "./EtiketView.vue?vue&type=script&lang=js&"
import style0 from "./EtiketView.vue?vue&type=style&index=0&id=15aea39c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports